import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { ClassicTable } from "../clientMaster/ClassicTable";
import {
  Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from "@mui/material";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../global";
import { AutoCompletes, DateInput, TextFields } from "../../../utils/Custom/custominput";
import SignatureCanvas from "../../SignatureCanvas";
import { generatePDFCustomerFeedback } from "./customerFeedbackPrint";
import { format } from "date-fns";
import { getPermissions } from "../rbac/hasAccess";

const initialCriteriaMap = {
  0: "deliveryServices",
  1: "qualityWork",
  2: "contractTime",
  3: "hired",
  4: "serviceRecommendation",
};

const EditCustomerFededback = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const PrintView = props?.print == true;
  const [inputStates, setInputStates] = React.useState({});
  const [clientList, setClientList] = React.useState([]);
  const [selectedIndexes, setSelectedIndexes] = React.useState({});
  const [criteriaMap, setCriteriaMap] = React.useState(initialCriteriaMap);
  const [letterHead, setLetterHead] = React.useState(true);

  const FeedbackTable = () => {
    const handleCheckboxChange = (rowIndex, index) => {
      setSelectedIndexes((prevSelectedIndexes) => ({
        ...prevSelectedIndexes,
        [criteriaMap[rowIndex]]: index,
      }));
    };

    const rows = [
      {
        description: " Our team delivered all contracted services.",
      },
      {
        description: "The quality of the contracted work was satisfactory.",
      },
      {
        description: "The contracted work was performed in a timely manner.",
      },
      {
        description: " You would hire us again?",
      },
      {
        description:
          "Would you recommend our service to contacts within your industry?",
      },
    ];

    return (
      <ClassicTable>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Parameter</TableCell>
                <TableCell>Strongly Agree</TableCell>
                <TableCell>Agree</TableCell>
                <TableCell>Neutral</TableCell>
                <TableCell>Disagree</TableCell>
                <TableCell>Strongly Disagree</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell style={{ width: "50%" }}>
                    <Text variant="p" className="text-sm">
                      {row.description}
                    </Text>
                  </TableCell>
                  {[1, 2, 3, 4, 5].map((value) => (
                    <TableCell key={value} style={{ width: "10%" }}>
                      <Checkbox
                        checked={
                          selectedIndexes[criteriaMap[rowIndex]] === value
                        }
                        onChange={() => handleCheckboxChange(rowIndex, value)}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ClassicTable>
    );
  };

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const inputFields = [
    {
      type: "TextField",
      label: "Customer Name",
      stateKey: "customerName",
      disabled: params.id != 0,
    },
    {
      type: "TextField",
      label: "Address - Location",
      stateKey: "address",
      disabled: params.id != 0,
    },
    {
      type: "TextField",
      label: "Contact Person Name",
      stateKey: "contactPerson",
      disabled: params.id != 0,
    },
    {
      type: "phoneNo",
      label: "Contact Person No.",
      stateKey: "mobileNumber",
      inputType: "number",
      disabled: params.id != 0,
    },
  ];

  const fetchcustomerFeedbackFormDetails = async () => {
    try {
      const query = `select * from customerFeedbackForm where id = ${params.id}`;
      const [customerFeedbackForm] = await fetchQuery(query);
      setInputStates(customerFeedbackForm);
      const tableData = {
        deliveryServices: customerFeedbackForm?.deliveryServices,
        qualityWork: customerFeedbackForm?.qualityWork,
        contractTime: customerFeedbackForm?.contractTime,
        hired: customerFeedbackForm?.hired,
        serviceRecommendation: customerFeedbackForm?.serviceRecommendation,
      };
      setSelectedIndexes(tableData);
    } catch (error) {
      console.error("Error fetching customerFeedbackForm:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchcustomerFeedbackFormDetails();
  }, [params]);

  const onSubmit = async () => {
    try {
      const {
        id,
        ...restInputStates
      } = inputStates;
      const payload = {
        ...restInputStates,
        deliveryServices: selectedIndexes.deliveryServices || null,
        qualityWork: selectedIndexes.qualityWork || null,
        contractTime: selectedIndexes.contractTime || null,
        hired: selectedIndexes.hired || null,
        serviceRecommendation: selectedIndexes.serviceRecommendation || null,
      };

      const url =
        BASE_URL +
        `customerFeedbackForm${params.id !== "0" ? `/${params.id}` : ""}`;

      params.id == 0
        ? await axiosWithToken.post(url, payload)
        : await axiosWithToken.patch(url, payload);

      toast.success(
        params.id == 0
          ? "Customer Feedback updated!"
          : "Customer Feedback Created!"
      );
      window.location.reload();
    } catch (error) {
      console.log(error.message || "Something Went Wrong!");
    }
  };


  return (
    <div>
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-600">
          {params.id == 0
            ? "Create New Customer Feedback"
            : `Update Customer Feedback`}
        </Text>
      )}
      {PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <div className="min-w-[250px]">
            <AutoCompletes
              label="Letter Head"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              valueKey="id"
              labelKey="label"
              value={letterHead ? 1 : 2}
              onChange={(val) => setLetterHead(val === 1)}
            />
          </div>
          <AddButton
            id="btn-print"
            label="Download PDF"
            onClick={async (e) => {
              await generatePDFCustomerFeedback(
                inputStates,
                selectedIndexes,
                letterHead
              );
            }}
          />
        </div>
      )}
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <Text className="mb-5">
        DYC Global Inspections Private Limited is always looking for ways and
        means for improving our services. With this aim in mind, we have decided
        to collect your formal feedback every year to understand your
        expectations and plan actions to try and improve.
        <br /> You are requested to kindly take few minutes and answer the
        following questions. Your comments and suggestions will be used to
        improve our system and ability to serve you better in future.
      </Text>
      {FeedbackTable()}
      <br />
      <br />

      <Text bold className="mb-1">
        Any Suggestions for our Organizational
      </Text>
      <TextFields
        id="standard-basic"
        value={inputStates?.suggestion1}
        onChange={(e) => updateInputObject("suggestion1", e.target.value)}
        disabled={PrintView}
        multiline
        minRows={1}
        maxRows={10}
      />

      <div>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="w-[20%]">
                <h6 className="text-left font-bold p-1">
                  {/* Name:
                  <br />
                  <br />
                  Signature:
                  <br />
                  <br /> */}
                  {/* Date: &nbsp;{" "} */}
                  <DateInput
                    id="from-date"
                    value={inputStates?.date}
                    onChange={(date) => {
                      const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                      updateInputObject("date", formattedDate);
                    }}
                    label={"Date"}
                  />
                </h6>
              </TableCell>
              <TableCell align="center" className="w-[40%]">
                <h6 className="text-left font-bold p-1">
                  PreparedBy Signature:
                </h6>
                <SignatureCanvas
                  updateUrl={(url) => {
                    updateInputObject("preparedBySign", url);
                  }}
                  url={inputStates?.preparedBySign}
                  disabled={PrintView}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {(permissions.save || permissions.create || permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={params.id == 0 ? "Save" : "Update"}
              onClick={onSubmit}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default EditCustomerFededback;
